import { createMuiTheme } from '@material-ui/core/styles';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';

import * as colours from 'colours';

const breakpoints = createBreakpoints({});
const commonProperties = {
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: colours.APP_PRIMARY,
      // dark: will be calculated from palette.primary.main,
      contrastText: colours.WHITE,
    },
    secondary: {
      main: colours.APP_SECONDARY,
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
    text: {
      primary: colours.APP_TEXT_PRIMARY,
      secondary: colours.APP_TEXT_SECONDARY,
    },
  },
  typography: {
    h1: {
      fontFamily: "'Raleway', 'Arial', 'Helvetica', sans-serif",
      fontWeight: 600,
      fontSize: '24px',
      lineHeight: '33.6px',
      color: colours.APP_SECONDARY,
      // marginTop: '8px',
      // marginBottom: '24px',
      // textAlign: 'center',
    },
    h2: {
      fontFamily: "'Raleway', 'Arial', 'Helvetica', sans-serif",
      fontWeight: 400,
      fontSize: '20px',
      lineHeight: '33.6px',
      color: colours.APP_SECONDARY,
      // marginBottom: '8px',
      // textAlign: 'left',
    },
    h3: {
      fontFamily: "'Raleway', 'Arial', 'Helvetica', sans-serif",
      fontWeight: 400,
      fontSize: '31px',
      lineHeight: '43.4px',
      color: colours.APP_PRIMARY,
      // textAlign: 'left',
      // marginBottom: '8px',
    },
    h4: {
      fontFamily: "'Raleway', 'Arial', 'Helvetica', sans-serif",
      fontWeight: 400,
      fontSize: '2rem',
      [breakpoints.up('xs')]: {
        fontSize: '1rem',
      },
      [breakpoints.up('sm')]: {
        fontSize: '1.5rem',
      },
      [breakpoints.up('md')]: {
        fontSize: '1.7rem',
      },
      [breakpoints.up('lg')]: {
        fontSize: '1.9rem',
      },
      lineHeight: '1px',
      color: colours.APP_PRIMARY,
    },
    body1: {
      fontFamily: "'Ubuntu', 'Arial', 'Helvetica', sans-serif",
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '25.6px',
      color: colours.APP_SECONDARY,
      // display: 'block',
      // marginBottom: '16px',
    },
    body2: {
      fontFamily: "'Ubuntu', 'Arial', 'Helvetica', sans-serif",
      fontSize: '12px',
      color: colours.APP_SECONDARY,
      // display: 'block',
      // marginBottom: '16px',
    },
    subtitle1: {
      fontFamily: "'Ubuntu', 'Arial', 'Helvetica', sans-serif",
      fontWeight: 400,
      fontSize: '2em',
      color: colours.APP_PRIMARY,
    },
    subtitle2: {
      fontFamily: "'Raleway', 'Arial', 'Helvetica', sans-serif",
      fontStyle: 'italic',
      fontWeight: '400',
      fontSize: '1.125rem',
      lineHeight: '20px',
    },
    button: {
      fontFamily: "'Raleway', 'Arial', 'Helvetica', sans-serif",
      fontSize: '14px',
      fontWeight: 'bold',
    },
  },
};

// https://material-ui.com/customization/palette/
// https://material-ui.com/customization/default-theme/
export const commonTheme = createMuiTheme({
  ...commonProperties,
  direction: window.localStorage.getItem('lan_dir_xh')
    ? window.localStorage.getItem('lan_dir_xh')
    : 'ltr',
});

export const stayActiveSectionTheme = createMuiTheme({
  ...commonProperties,
  direction: window.localStorage.getItem('lan_dir_xh')
    ? window.localStorage.getItem('lan_dir_xh')
    : 'ltr',

  palette: {
    ...commonProperties.palette,
    primary: {
      main: colours.APP_SECTION_STAY_ACTIVE,
    },
  },
  typography: {
    ...commonProperties.typography,
    h3: {
      ...commonProperties.typography.h3,
      color: colours.APP_SECTION_STAY_ACTIVE,
    },
    subtitle1: {
      ...commonProperties.typography.subtitle1,
      color: colours.APP_SECTION_STAY_ACTIVE,
    },
  },
});

export const eatFreshSectionTheme = createMuiTheme({
  ...commonProperties,
  direction: window.localStorage.getItem('lan_dir_xh')
    ? window.localStorage.getItem('lan_dir_xh')
    : 'ltr',

  palette: {
    ...commonProperties.palette,
    primary: {
      main: colours.APP_SECTION_EAT_FRESH,
    },
  },
  typography: {
    ...commonProperties.typography,
    h3: {
      ...commonProperties.typography.h3,
      color: colours.APP_SECTION_EAT_FRESH,
    },
    subtitle1: {
      ...commonProperties.typography.subtitle1,
      color: colours.APP_SECTION_EAT_FRESH,
    },
  },
});
export const beProductiveSectionTheme = createMuiTheme({
  ...commonProperties,
  direction: window.localStorage.getItem('lan_dir_xh')
    ? window.localStorage.getItem('lan_dir_xh')
    : 'ltr',

  palette: {
    ...commonProperties.palette,
    primary: {
      main: colours.APP_SECTION_BE_PRODUCTIVE,
    },
  },
  typography: {
    ...commonProperties.typography,
    h3: {
      ...commonProperties.typography.h3,
      color: colours.APP_SECTION_BE_PRODUCTIVE,
    },
    subtitle1: {
      ...commonProperties.typography.subtitle1,
      color: colours.APP_SECTION_BE_PRODUCTIVE,
    },
  },
});
export const restSectionTheme = createMuiTheme({
  ...commonProperties,
  direction: window.localStorage.getItem('lan_dir_xh')
    ? window.localStorage.getItem('lan_dir_xh')
    : 'ltr',

  palette: {
    ...commonProperties.palette,
    primary: {
      main: colours.APP_SECTION_REST,
    },
  },
  typography: {
    ...commonProperties.typography,
    h3: {
      ...commonProperties.typography.h3,
      color: colours.APP_SECTION_REST,
    },
    subtitle1: {
      ...commonProperties.typography.subtitle1,
      color: colours.APP_SECTION_REST,
    },
  },
});
